import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { BiChevronRight } from 'react-icons/bi'
import { useLocation } from 'react-router'
import { handleLabelNameChanges } from 'src/cms/helpers/automation'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const { pathname } = useLocation()
  const { config } = useLayout()
  const { aside } = config

  const [isOpen, setIsOpen] = useState(false)

  const isActive = checkIsActive(pathname, to)

  useEffect(() => {
    if (isActive) {
      setIsOpen(true)
    }
  }, [pathname, isActive])

  return (
    <div
      className={clsx('menu-item', { 'here show': isActive || isOpen }, 'menu-accordion')}
      data-kt-menu-trigger='click'
      data-cy={`${handleLabelNameChanges(title)}-menu`}
    >
      <span className='menu-link' data-cy={`${handleLabelNameChanges(title)}-menu-link`} onClick={() => setIsOpen(prev => !prev)}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'>
          <BiChevronRight />
        </span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', { show: isOpen, 'menu-active-bg': isActive })}>
        {children}
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }
